import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session5 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respQuestionsChoix, setRespQuestionsChoix] = React.useState('');
  const [respQuestionsSlogan, setRespQuestionsSlogan] = React.useState('');
  const [respQuestionsMotsCle, setRespQuestionsMotsCle] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bienvenue dans cette nouvelle session !</h3>
            <p>
              Quand vous êtes à l’école, on vous demande souvent de réfléchir,
              de vous concentrer… ça veut dire quoi, exactement ?
            </p>
            <p>
              Partons à la découverte de ce qu’on appelle la cognition, et
              regardons comment ça pourrait nous aider à être altruiste.
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1kRlLBRIscYwqA-zatYK3EXz8ff_C_T9oG0E6FgG-B88"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Une des régions du cerveau associée à l’attention est :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="lobeFrontal"
                  control={<Radio />}
                  label="Le lobe frontal"
                />
                <FormControlLabel
                  value="lobePosterieur"
                  control={<Radio />}
                  label="Le lobe postérieur"
                />
                <FormControlLabel
                  value="lobeAnterieur"
                  control={<Radio />}
                  label="Le lobe antérieur"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>Après la concentration, place à la détente…</p>
            <p>
              Sur les deux prochaines séances, nous allons imaginer que tu
              décris ta série préférée, ou ton film préféré, à travers une
              affiche.
            </p>
            <p>
              L’objectif de cette affiche est de montrer pourquoi tu aimes cette
              série à des amis ou des camarades.
            </p>
            <p>Allons-y !</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>Avant tout, il faut que tu choisisses une série ou un film :</p>
            <TextField
              fullWidth
              id="questionsChoix"
              label="Ton choix"
              variant="outlined"
              value={respQuestionsChoix}
              onChange={(e) => {
                setRespQuestionsChoix(e.target.value);
              }}
            />
            <p>
              Maintenant, choisis un slogan. Un{' '}
              <span style={{fontStyle: 'italic'}}>slogan</span>, c’est comme le
              message principal que tu voudrais faire passer :
            </p>
            <TextField
              fullWidth
              id="questionsSlogan"
              label="Ton slogan"
              variant="outlined"
              value={respQuestionsSlogan}
              onChange={(e) => {
                setRespQuestionsSlogan(e.target.value);
              }}
            />
            <p>
              Enfin, fais la liste de plusieurs mots importants, des{' '}
              <span style={{fontStyle: 'italic'}}>mots-clé</span>, que tu
              voudrais écrire sur ton affiche :{' '}
            </p>
            <TextField
              fullWidth
              id="questionsMotsCle"
              label="Tes mots-clé"
              variant="outlined"
              value={respQuestionsMotsCle}
              onChange={(e) => {
                setRespQuestionsMotsCle(e.target.value);
              }}
            />
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. N’oublie pas de te
              reconnecter dans quelques jours pour notre prochaine séance.
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Aujourd’hui tu as découvert que le comportement altruiste
                implique de nombreux autres mécanismes au niveau de la
                perception et de l’attention.
              </p>
              <p>
                Maintenant, place à la créativité pour que d’autres fassent
                attention à la cause de ton choix !
              </p>
              <p>
                Sur les deux prochaines séances, tu vas pouvoir créer un poster
                pour représenter le thème que tu as choisi. L’objectif de ce
                poster est de donner envie aux autres de s’impliquer.{' '}
              </p>
              <p>Allons-y !</p>
            </div>
          )}

        {group.toString() === 'test_a' && scr === 3 && (
          <div>
            <p>
              Avant tout, il faut que tu choisisses un thème, ou un sujet, lié à
              l’écologie :
            </p>
            <TextField
              fullWidth
              id="questionsChoix"
              label="Ton choix"
              variant="outlined"
              value={respQuestionsChoix}
              onChange={(e) => {
                setRespQuestionsChoix(e.target.value);
              }}
            />
            <p>
              Maintenant, choisis un slogan. Un{' '}
              <span style={{fontStyle: 'italic'}}>slogan</span>, c’est comme le
              message principal que tu voudrais faire passer :
            </p>
            <TextField
              fullWidth
              id="questionsSlogan"
              label="Ton slogan"
              variant="outlined"
              value={respQuestionsSlogan}
              onChange={(e) => {
                setRespQuestionsSlogan(e.target.value);
              }}
            />
            <p>
              Enfin, fais la liste de plusieurs mots importants, des{' '}
              <span style={{fontStyle: 'italic'}}>mots-clé</span>, que tu
              voudrais écrire sur ton affiche :{' '}
            </p>
            <TextField
              fullWidth
              id="questionsMotsCle"
              label="Tes mots-clé"
              variant="outlined"
              value={respQuestionsMotsCle}
              onChange={(e) => {
                setRespQuestionsMotsCle(e.target.value);
              }}
            />
          </div>
        )}
        {group.toString() === 'test_b' && scr === 3 && (
          <div>
            <p>
              Avant tout, il faut que tu choisisses un thème, ou un sujet, lié à
              la santé et aux personnes hospitalisées :
            </p>
            <TextField
              fullWidth
              id="questionsChoix"
              label="Ton choix"
              variant="outlined"
              value={respQuestionsChoix}
              onChange={(e) => {
                setRespQuestionsChoix(e.target.value);
              }}
            />
            <p>
              Maintenant, choisis un slogan. Un{' '}
              <span style={{fontStyle: 'italic'}}>slogan</span>, c’est comme le
              message principal que tu voudrais faire passer :
            </p>
            <TextField
              fullWidth
              id="questionsSlogan"
              label="Ton slogan"
              variant="outlined"
              value={respQuestionsSlogan}
              onChange={(e) => {
                setRespQuestionsSlogan(e.target.value);
              }}
            />
            <p>
              Enfin, fais la liste de plusieurs mots importants, des{' '}
              <span style={{fontStyle: 'italic'}}>mots-clé</span>, que tu
              voudrais écrire sur ton affiche :{' '}
            </p>
            <TextField
              fullWidth
              id="questionsMotsCle"
              label="Tes mots-clé"
              variant="outlined"
              value={respQuestionsMotsCle}
              onChange={(e) => {
                setRespQuestionsMotsCle(e.target.value);
              }}
            />
          </div>
        )}
        {group.toString() === 'test_c' && scr === 3 && (
          <div>
            <p>
              Avant tout, il faut que tu choisisses un thème, ou un sujet, lié à
              la précarité et aux personnes en situation de pauvreté :
            </p>
            <TextField
              fullWidth
              id="questionsChoix"
              label="Ton choix"
              variant="outlined"
              value={respQuestionsChoix}
              onChange={(e) => {
                setRespQuestionsChoix(e.target.value);
              }}
            />
            <p>
              Maintenant, choisis un slogan. Un{' '}
              <span style={{fontStyle: 'italic'}}>slogan</span>, c’est comme le
              message principal que tu voudrais faire passer :
            </p>
            <TextField
              fullWidth
              id="questionsSlogan"
              label="Ton slogan"
              variant="outlined"
              value={respQuestionsSlogan}
              onChange={(e) => {
                setRespQuestionsSlogan(e.target.value);
              }}
            />
            <p>
              Enfin, fais la liste de plusieurs mots importants, des{' '}
              <span style={{fontStyle: 'italic'}}>mots-clé</span>, que tu
              voudrais écrire sur ton affiche :{' '}
            </p>
            <TextField
              fullWidth
              id="questionsMotsCle"
              label="Tes mots-clé"
              variant="outlined"
              value={respQuestionsMotsCle}
              onChange={(e) => {
                setRespQuestionsMotsCle(e.target.value);
              }}
            />
          </div>
        )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. Rendez-vous à la prochaine
                séance, lors de laquelle tu pourras créer et dessiner ton
                poster.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session5')
              .add({
                date: now,
                response: response,
                respQuestionsChoix: respQuestionsChoix,
                respQuestionsSlogan: respQuestionsSlogan,
                respQuestionsMotsCle: respQuestionsMotsCle,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session5;
